"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Close_1 = tslib_1.__importDefault(require("@mui/icons-material/Close"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const ColumnList_1 = tslib_1.__importDefault(require("./ColumnList"));
const ColumnSearch_1 = tslib_1.__importDefault(require("./ColumnSearch"));
const getStyles = () => ({
    container: {
        padding: [2, 2, 1, 2],
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        "& >:last-child": { p: 0, alignSelf: "baseline" },
    },
});
const ColumnSelectorPopover = (props) => {
    const { title: defaultTitle, buttonResetText: buttonResetTextDefault } = (0, styles_1.useThemeProps)({
        props,
        name: "ColumnSelectorPopover",
    });
    const { title = defaultTitle, onClose, ColumnSearchProps, ColumnListProps, searchTerm, ButtonResetProps, buttonResetText = buttonResetTextDefault, setSearchTerm, ...rest } = props;
    const styles = getStyles();
    return (react_1.default.createElement(Popover_1.default, { onClose: () => onClose(), ...rest },
        react_1.default.createElement(Box_1.default, { sx: styles.container },
            react_1.default.createElement(Box_1.default, { sx: styles.header },
                react_1.default.createElement(Typography_1.default, { variant: "h6" }, title),
                react_1.default.createElement(IconButton_1.default, { onClick: () => onClose() },
                    react_1.default.createElement(Close_1.default, null))),
            react_1.default.createElement(ColumnSearch_1.default, { autoFocus: ColumnListProps?.items?.length !== 0 ? true : false, onChange: (e) => setSearchTerm(e.target.value), ...ColumnSearchProps }),
            react_1.default.createElement(ColumnList_1.default, { searchTerm: searchTerm, ...ColumnListProps })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(Button_1.default, { sx: { m: 1 }, children: buttonResetText, ...ButtonResetProps })));
};
exports.default = ColumnSelectorPopover;
